import React from "react"
import { conversationShape } from "utils/propTypeShapes"
import Conversation from "shared/Conversation"

const CLOSED_TEXT = "This conversation is closed. New messages may no longer be added."

const PublicConversation = ({ conversation }) => {
  const { closed } = conversation

  return (
    <Conversation
      canAddMessages={!closed}
      canTakeActions={false}
      conversation={conversation}
      text={closed ? CLOSED_TEXT : ""}
    />
  )
}

PublicConversation.propTypes = {
  conversation: conversationShape.isRequired,
}

export default PublicConversation
